{
  "title": "Produits",
  "subtitle": "Tout ce que vous gardez en stock. Ouvrez un produit pour voir où il se trouve et comment il a bougé.",
  "importFromExcel": "Importer depuis Excel",
  "exportToExcel": "Exporter vers Excel",
  "newProduct": "Nouveau produit",
  "status": {
    "active": "Actif",
    "archived": "Archivé"
  },
  "states": {
    "in_stock": "En stock",
    "low": "Bas",
    "out": "Rupture",
    "negative": "Négatif",
    "overstock": "Surstock"
  },
  "tabs": {
    "all": "Tous",
    "low": "Bas",
    "out": "Rupture",
    "negative": "Négatif",
    "overstock": "Surstock",
    "archived": "Archivés"
  },
  "empty": {
    "title": "Aucun produit pour l'instant",
    "text": "Ajoutez vos produits un par un, ou importez tout votre catalogue depuis un fichier Excel ou CSV."
  },
  "noMatch": {
    "title": "Aucun produit ne correspond",
    "text": "Essayez un autre mot, ou effacez les filtres."
  },
  "filters": {
    "search": "Nom, référence ou code-barres",
    "category": "Catégorie",
    "allCategories": "Toutes les catégories",
    "brand": "Marque",
    "allBrands": "Toutes les marques",
    "sort": "Tri",
    "clear": "Effacer",
    "attribute": "Attribut",
    "allAttributes": "Tous les attributs",
    "attributeValue": "Valeur de {{name}}",
    "anyValue": "Toute valeur",
    "contains": "Contient…",
    "min": "De",
    "max": "À",
    "attributeMin": "{{name}} à partir de",
    "attributeMax": "{{name}} jusqu'à"
  },
  "sort": {
    "name_asc": "Nom de A à Z",
    "name_desc": "Nom de Z à A",
    "sku_asc": "Référence de A à Z",
    "sku_desc": "Référence de Z à A",
    "stock_asc": "Plus petit stock d'abord",
    "stock_desc": "Plus gros stock d'abord",
    "createdAt_asc": "Plus anciens d'abord",
    "createdAt_desc": "Plus récents d'abord"
  },
  "columns": {
    "product": "Produit",
    "codes": "Référence · Code-barres",
    "totalStock": "Stock total",
    "minMax": "Min / Max",
    "averageCost": "Coût moyen",
    "sellingPrice": "Prix de vente",
    "stockValue": "Valeur du stock",
    "state": "État",
    "location": "Emplacement",
    "min": "Min",
    "max": "Max",
    "quantity": "Quantité",
    "value": "Valeur (TND)"
  },
  "showing_one": "{{first}}–{{last}} sur {{total}} produit",
  "showing_many": "{{first}}–{{last}} sur {{total}} produits",
  "showing_other": "{{first}}–{{last}} sur {{total}} produits",
  "pricesIn": "prix en TND",
  "fields": {
    "name": "Nom du produit",
    "description": "Description",
    "category": "Catégorie",
    "categories": "Catégories",
    "brand": "Marque",
    "unit": "Unité",
    "sku": "Référence",
    "skuLong": "Référence (votre code produit)",
    "barcode": "Code-barres",
    "costPrice": "Prix de revient de référence",
    "sellingPrice": "Prix de vente",
    "taxRate": "Taux de TVA",
    "listPrice": "Prix {{list}}"
  },
  "photo": {
    "title": "Photo",
    "alt": "Photo du produit",
    "drop": "Déposez une photo ou cliquez pour choisir",
    "limits": "JPG, PNG ou WebP, 5 Mo maximum",
    "change": "Changer",
    "remove": "Retirer",
    "wrongType": "Utilisez une image JPG, PNG ou WebP",
    "tooLarge": "La photo doit faire 5 Mo au maximum"
  },
  "form": {
    "newTitle": "Nouveau produit",
    "editTitle": "Modifier",
    "subtitle": "Les champs marqués * sont obligatoires. Tout peut être modifié plus tard, sauf la référence une fois que le produit a bougé.",
    "sections": {
      "what": "1 · De quoi s'agit-il ?",
      "codes": "2 · Codes",
      "prices": "3 · Prix",
      "warn": "4 · Quand faut-il vous prévenir ?",
      "attributes": "5 · Attributs",
      "customizations": "6 · Personnalisations"
    },
    "choose": "Choisir…",
    "noBrand": "Sans marque",
    "deactivated": "désactivé",
    "noCategories": "Il n'y a pas encore de catégorie : créez d'abord l'arbre des catégories.",
    "addCategory": "Ajouter une catégorie…",
    "categoriesHint": "Le produit se trouve dans chacune. La première est la principale : les rapports et le fil d’Ariane de la boutique l’utilisent.",
    "categoriesFull": "C’est le maximum : {{max}} catégories.",
    "mainCategory": "Principale",
    "makeMain": "Rendre principale",
    "removeCategory": "Retirer {{name}}",
    "openConfiguration": "Ouvrir la configuration",
    "wholeNumbers": "nombres entiers",
    "decimals_one": "{{count}} décimale",
    "decimals_many": "{{count}} décimales",
    "decimals_other": "{{count}} décimales",
    "skuAuto": "Créez-la pour moi :",
    "skuManual": "Je saisis mon propre code",
    "skuHint": "Majuscules, chiffres, points, tirets et barres obliques.",
    "skuLocked": "La référence ne peut plus changer : ce produit a déjà bougé.",
    "skuAutoTaken": "Cette référence automatique vient d'être utilisée : enregistrez à nouveau pour obtenir la suivante.",
    "barcodeFree": "Disponible : aucun autre produit n'a ce code-barres",
    "barcodeTaken": "Ce code-barres appartient déjà à {{name}} ({{sku}}).",
    "generateBarcode": "Pas de code-barres ? En générer un interne",
    "costHint": "Seulement proposé à la réception. Le coût réel est la moyenne calculée par le système.",
    "priceHint": "3 décimales, comme sur les factures tunisiennes.",
    "taxRateHint": "Les prix sont TTC ; les tickets détaillent la TVA de ce taux.",
    "noTaxRates": "Aucun taux de TVA : ajoutez vos taux dans Configuration, Ventes.",
    "defaultTaxRate": "Défaut de la société ({{name}} · {{rate}})",
    "noTaxRate": "Sans TVA (0 %)",
    "listPriceHint": "Vide : se vend au prix de vente.",
    "warnHint": "À chaque emplacement : à son minimum ou en dessous, vous recevez une alerte « Stock bas » ; au-delà de son maximum, une alerte « Surstock ». Les limites d’un site comptent aussi ses sous-emplacements. Laissez un emplacement vide pour n’en fixer aucune.",
    "afterSaving": "Après l'enregistrement",
    "afterSavingText": "Le produit démarre à 0 dans chaque emplacement. Ajoutez les quantités que vous avez déjà avec un stock d'ouverture, ou recevez de la marchandise avec une entrée de stock (phase 3).",
    "saveAndAdd": "Enregistrer et en ajouter un autre",
    "saveProduct": "Enregistrer le produit",
    "saved": "Produit enregistré",
    "created": "{{name}} créé sous la référence {{sku}}",
    "sectionsVariants": {
      "what": "1 · De quoi s'agit-il ?",
      "options": "2 · Options",
      "codes": "3 · Code",
      "prices": "4 · Prix",
      "variants": "7 · Variantes",
      "attributes": "5 · Attributs",
      "customizations": "6 · Personnalisations"
    },
    "wholesaleHint": "Vide : pas de prix de gros, il n'est donc pas vendu en mode gros."
  },
  "detail": {
    "more": "Plus d'actions",
    "brand": "Marque : {{name}}",
    "unit": "Unité : {{name}} ({{symbol}})",
    "negativeIn_one": "Négatif dans {{count}} emplacement",
    "negativeIn_many": "Négatif dans {{count}} emplacements",
    "negativeIn_other": "Négatif dans {{count}} emplacements",
    "negativeShows": "{{location}} affiche {{quantity}} {{unit}}.",
    "negativeExplain": "On a sorti plus que ce que le système avait. Comptez le rayon, ou enregistrez la réception oubliée.",
    "totalStock": "Stock total",
    "averageCost": "Coût moyen",
    "averageCostHint": "Moyenne pondérée, calculée par le système",
    "stockValue": "Valeur du stock",
    "noCostYet": "Aucune réception pour l'instant",
    "sellingPrice": "Prix de vente",
    "margin": "Marge d'environ {{percent}} % sur le coût moyen",
    "pricesTitle": "Prix",
    "pricesHint": "TTC, par liste de prix",
    "fromSellingPrice": "Prix de vente",
    "fromProduct": "Celui de l’article",
    "ownPrice": "Prix propre",
    "noPrice": "Sans prix",
    "whereItIs": "Où il se trouve",
    "perLocationHint": "Le min et le max peuvent être fixés par emplacement",
    "noLocations": "Aucun emplacement pour l'instant : créez vos sites dans Emplacements.",
    "systemLocation": "Emplacement système",
    "empty": "Vide",
    "total": "Total",
    "changes": "Modifications de ce produit",
    "changesHint": "Chaque modification est enregistrée et ne peut jamais être changée.",
    "details": "Détails du produit",
    "unitDecimals_one": "{{name}} ({{count}} décimale)",
    "unitDecimals_many": "{{name}} ({{count}} décimales)",
    "unitDecimals_other": "{{name}} ({{count}} décimales)",
    "created": "Créé",
    "lastChange": "Dernière modification",
    "dateBy": "{{date}} par {{name}}",
    "archive": "Archiver le produit",
    "archiveHint": "L'archivage n'est possible que lorsque le stock est à zéro dans tous les emplacements.",
    "canDeleteHint": "Ce produit n'a jamais servi : il peut aussi être supprimé.",
    "cannotDeleteHint": "Ce produit a un historique : il ne peut pas être supprimé.",
    "archiveTitle": "Archiver {{name}} ?",
    "archiveText": "Il sort des listes et ne peut plus être reçu ni sorti. Son historique reste, et vous pouvez le restaurer à tout moment.",
    "archived": "Produit archivé",
    "restore": "Restaurer le produit",
    "restoreHint": "La restauration remet le produit dans les listes et les opérations.",
    "restored": "Produit restauré",
    "delete": "Supprimer le produit",
    "deleteTitle": "Supprimer {{name}} ?",
    "deleteText": "Ce produit n'a jamais servi. Il est supprimé définitivement ; le journal d'activité garde une trace de la suppression.",
    "deleted": "{{name}} supprimé",
    "receive": "Recevoir",
    "issue": "Sortir",
    "correctStock": "Corriger le stock",
    "seeStockLevels": "Le voir dans les niveaux de stock",
    "movements": "Historique des mouvements",
    "allLocations": "Tous les emplacements",
    "export": "Exporter",
    "noMovement": "Aucun mouvement pour l'instant : recevez du stock ou saisissez le stock d'ouverture.",
    "when": "Quand",
    "document": "Document",
    "change": "Variation",
    "balanceAfter": "Solde après",
    "by": "Par",
    "reversal": "contrepassation",
    "atCost": "à {{cost}} TND",
    "negativeConfirmed": "Négatif confirmé",
    "fullHistory": "Voir tout l'historique dans le journal d'activité",
    "loadMore": "Afficher plus",
    "pastDate": "Stock à une date passée",
    "pastDateHint": "Chaque mouvement est conservé : vous voyez la quantité à n'importe quel jour.",
    "date": "Date",
    "totalThen": "Total à cette date",
    "reservedAt": "{{site}} : {{reserved}} {{unit}} réservé(s) pour des commandes, {{available}} disponible(s)",
    "noWholesale": "Non défini : pas vendu en gros"
  },
  "kind": {
    "label": "Type de produit",
    "simple": "Produit simple",
    "simpleHint": "Un seul article : un SKU, un code-barres, un stock.",
    "parent": "Produit avec variantes",
    "parentHint": "Existe en plusieurs couleurs, tailles ou finitions. Chaque variante a son SKU, son code-barres et son stock."
  },
  "variants": {
    "optionsHint": "Ce qui distingue les variantes, jusqu'à 3 options. Chaque combinaison de valeurs est une variante.",
    "noOptions": "Aucune option pour l'instant. Ajoutez la première : Couleur, Taille, Matière…",
    "addOption": "Ajouter une option",
    "customOption": "Nouvelle option, saisie à la main",
    "valueCount_one": "{{count}} valeur",
    "valueCount_other": "{{count}} valeurs",
    "maxOptions": "3 options au maximum.",
    "optionName": "Option",
    "optionNamePlaceholder": "Couleur, Taille, Matière…",
    "presentation": "Affichée en",
    "optionUsed": "Ses valeurs sont utilisées par des variantes",
    "removeOption": "Retirer l'option {{name}}",
    "pick": "Choisir dans la bibliothèque",
    "values": "Valeurs",
    "codeHint": "(le code entre dans le SKU des variantes)",
    "noValues": "Aucune valeur : choisissez-en ci-dessus ou saisissez-les ci-dessous.",
    "label": "Valeur",
    "code": "Code",
    "color": "Couleur de {{name}}",
    "removeValue": "Retirer {{name}}",
    "valueUsed_one": "Utilisée par {{count}} variante",
    "valueUsed_other": "Utilisée par {{count}} variantes",
    "addValues": "Ajouter des valeurs",
    "addValuesPlaceholder": "Saisissez une valeur puis Entrée. Les virgules en ajoutent plusieurs.",
    "add": "Ajouter",
    "existingTake": "Les variantes existantes sont",
    "existingHint": "Elles prennent cette valeur de la nouvelle option.",
    "skuHint": "Chaque variante reçoit ce SKU suivi des codes de ses valeurs (PNT-10L-WHT), sauf si vous saisissez le sien.",
    "pricesHint": "Les variantes sans prix propre utilisent ceux-ci.",
    "listPriceHint": "Vide : les variantes se vendent à leur prix de vente, sauf si elles ont le leur.",
    "tableHint": "Une ligne par combinaison. Décochez celles que vous ne vendez pas. Les SKU et prix vides suivent le produit.",
    "noRows": "Ajoutez une option et ses valeurs : les combinaisons s'affichent ici.",
    "count_one": "{{count}} variante",
    "count_other": "{{count}} variantes",
    "newCount_one": "{{count}} nouvelle",
    "newCount_other": "{{count}} nouvelles",
    "tooMany": "{{count}} combinaisons : {{max}} variantes au maximum. Utilisez moins de valeurs.",
    "needOption": "Ajoutez au moins une option avec ses valeurs.",
    "none": "Cochez au moins une combinaison.",
    "stranded": "Certaines variantes ne correspondent plus à une combinaison : remettez les options et valeurs qu'elles utilisent.",
    "fixErrors": "Certaines options ou variantes sont à corriger.",
    "saved_one": "{{name}} enregistré avec {{count}} variante",
    "saved_other": "{{name}} enregistré avec {{count}} variantes",
    "selectAll": "Créer toutes les nouvelles combinaisons",
    "createRow": "Créer {{label}}",
    "keepRow": "{{label}} en service",
    "hasStock": "Elle a du stock : elle reste en service",
    "new": "Nouvelle",
    "archived": "Archivée",
    "inStock": "{{quantity}} {{unit}} en stock",
    "columns": {
      "active": "En service",
      "variant": "Variante",
      "sku": "SKU",
      "barcode": "Code-barres",
      "costPrice": "Prix de revient",
      "sellingPrice": "Prix de vente"
    },
    "bulk": {
      "scope": "Remplir pour",
      "all": "Toutes les variantes",
      "field": "Champ",
      "value": "Valeur",
      "empty": "Vide",
      "apply": "Remplir",
      "hint": "Une valeur vide efface le champ : les variantes suivent de nouveau le produit."
    },
    "convert": {
      "teaser": "Existe en plusieurs couleurs ou tailles ?",
      "teaserText": "Transformez-le en produit avec variantes. Cet article devient sa première variante et garde son stock et son historique.",
      "action": "Ajouter des variantes",
      "title": "Ajouter des variantes à {{name}}",
      "description": "Choisissez les options. Cet article devient la première variante ; vous ajoutez les autres ensuite. Les modifications non enregistrées sur cette page sont perdues.",
      "thisIs": "Cet article ({{sku}}) est",
      "parentSku": "SKU du produit avec variantes",
      "parentSkuHint": "Laissez vide pour le prochain SKU automatique. L'article garde {{sku}}.",
      "submit": "Ajouter des variantes",
      "done": "{{name}} a maintenant des variantes : cochez les autres combinaisons et enregistrez."
    },
    "page": {
      "variantOf": "Variante de",
      "edit": "Modifier les variantes",
      "title": "Variantes",
      "hint": "Chaque variante a son SKU, son code-barres et son stock. Cliquez sur une photo pour la changer.",
      "none": "Aucune variante : modifiez le produit pour cocher ses combinaisons.",
      "ownPrice": "prix propre",
      "archivedCount_one": "{{count}} variante archivée",
      "archivedCount_other": "{{count}} variantes archivées",
      "changePhoto": "Changer la photo de {{label}}",
      "photoSaved": "Photo de {{label}} enregistrée",
      "statVariants": "Variantes",
      "inStockCount_one": "{{count}} en stock",
      "inStockCount_other": "{{count}} en stock",
      "valueNote": "Chaque variante à son coût moyen",
      "pickerTitle": "Variante",
      "pickerHint": "Choisissez une autre valeur pour ouvrir cette variante.",
      "unavailable": "{{label}} (aucune)",
      "archiveHint": "Le produit est archivé avec ses variantes, seulement quand aucune n'a de stock.",
      "archiveText": "Le produit et ses variantes actives sortent des listes et ne peuvent plus être reçus ni sortis. Leur historique reste ; restaurer le produit les fait revenir.",
      "deleteText": "Le produit et ses variantes n'ont jamais servi. Ils sont supprimés définitivement ; le journal d'activité garde une trace de la suppression."
    },
    "grid": {
      "title": "{{name}} : quantité par variante",
      "hint": "Saisissez une quantité pour chaque variante à ajouter ; laissez les autres vides.",
      "hintAt": "Saisissez une quantité pour chaque variante à ajouter ; laissez les autres vides. Stock affiché à {{location}}.",
      "quantity": "Quantité",
      "quantityOf": "Quantité de {{label}}",
      "stock": "{{quantity}} en stock",
      "setAll": "Même quantité pour toutes",
      "apply": "Remplir",
      "summary_one": "{{count}} variante, {{total}} {{unit}} au total",
      "summary_other": "{{count}} variantes, {{total}} {{unit}} au total",
      "add_one": "Ajouter {{count}} ligne",
      "add_other": "Ajouter {{count}} lignes",
      "addNone": "Ajouter",
      "empty": "Ce produit n'a aucune variante active : modifiez-le pour en ajouter.",
      "pick_one": "{{count}} variante · saisir les quantités",
      "pick_other": "{{count}} variantes · saisir les quantités"
    },
    "wholesaleHint": "Vide : les variantes n'ont pas de prix de gros, sauf le leur.",
    "limits": {
      "at": "Limites à",
      "hint": "Le minimum et le maximum de chaque variante à cet emplacement : à son minimum ou en dessous, une alerte « Stock bas » ; au-delà de son maximum, une alerte « Surstock ». Celles d’un site comptent aussi ses sous-emplacements. Choisissez un autre emplacement pour fixer les siennes : ce que vous avez saisi reste.",
      "option": "{{name}} ({{count}})",
      "toCheck": "{{name}} · à vérifier",
      "elsewhere": "Limites à vérifier à : {{places}}",
      "minAt": "Min à {{place}}",
      "maxAt": "Max à {{place}}",
      "bulkHint": "Une valeur vide retire la limite."
    },
    "view": {
      "label": "Ce que montre le tableau",
      "prices": "Codes et prix",
      "limits": "Limites de stock",
      "pricesToCheck": "Des codes ou des prix sont à vérifier : voir Codes et prix."
    }
  },
  "extras": {
    "fixErrors": "Certains attributs ou personnalisations sont à corriger.",
    "attributes": {
      "hint": "Ce qui décrit le produit, depuis la bibliothèque d'attributs : poids, matière, étanchéité. Ils aident à trouver et comparer les produits ; ils ne créent pas de variantes.",
      "none": "Aucun attribut pour le moment.",
      "add": "Ajouter un attribut",
      "emptyLibrary": "La bibliothèque d'attributs est vide.",
      "yes": "Oui",
      "no": "Non",
      "remove": "Retirer {{name}}"
    },
    "customizations": {
      "hint": "Demandées quand l'article sort : texte de gravure, teinte, longueur coupée. Elles sont notées sur la ligne de sortie et n'ont pas de stock propre.",
      "none": "Aucune personnalisation.",
      "add": "Ajouter une personnalisation",
      "name": "Personnalisation",
      "namePlaceholder": "Teinte, Gravure, Longueur…",
      "type": "Réponse",
      "types": {
        "choice": "Une liste de choix",
        "text": "Un texte libre",
        "number": "Un nombre"
      },
      "choices": "Choix",
      "choicesPlaceholder": "Saisissez un choix puis Entrée. Les virgules en ajoutent plusieurs.",
      "removeChoice": "Retirer {{name}}",
      "unit": "Unité",
      "required": "Obligatoire à chaque sortie",
      "remove": "Retirer la personnalisation {{name}}",
      "title": "Personnalisations",
      "pageHint": "Demandées à chaque sortie de ce produit.",
      "requiredBadge": "Obligatoire"
    }
  },
  "online": {
    "title": "Boutique en ligne",
    "hint": "Si l’article est vendu en ligne, son titre là-bas, et ses photos.",
    "published": "En ligne",
    "notPublished": "Hors ligne",
    "sold": "Vendu en ligne",
    "soldHint": "Affiché dans la boutique en ligne, au tarif en ligne.",
    "archived": "Un article archivé n’est pas vendu en ligne.",
    "titleField": "Titre en ligne",
    "titleHint": "Vide : le nom de l’article.",
    "slug": "Adresse",
    "slugHint": "La fin de l’adresse de la page de l’article. La changer casse les anciens liens.",
    "slugAuto": "Vide : faite à partir du titre ({{slug}}).",
    "description": "Description en ligne",
    "descriptionHint": "Vide : la description de l’article.",
    "sortOrder": "Ordre dans la boutique",
    "sortOrderHint": "Les plus petits nombres viennent en premier.",
    "save": "Enregistrer la boutique en ligne",
    "saved": "Boutique en ligne enregistrée",
    "savedPublished": "L’article est dans la boutique en ligne",
    "gallery": "Photos {{count}}/{{max}}",
    "galleryHint": "Affichées après la photo principale, dans cet ordre (JPEG, PNG ou WebP).",
    "noPhotos": "Aucune photo en plus de la principale.",
    "addPhoto": "Ajouter une photo",
    "removePhoto": "Retirer la photo",
    "moveLeft": "Avancer",
    "moveRight": "Reculer",
    "variant": "Une variante est vendue en ligne avec son article :"
  },
  "selling": {
    "title": "Vente",
    "saved": "Enregistré",
    "onSale": "En vente",
    "offSale": "Hors vente",
    "onSaleHint": "Vendu aux caisses, en ligne (s'il est publié) et dans les commandes.",
    "onSaleVariant": "Cette variante est vendue partout où son produit l'est.",
    "offSaleHint": "Vendu nulle part pour l'instant. Son stock reste, peut être compté et déplacé ; remettez-le en vente quand vous voulez.",
    "parentOff": "{{name}} est hors vente : aucune de ses variantes n'est vendue.",
    "shownOnline": "Visible en ligne",
    "shownOnlineHint": "Proposée dans la boutique en ligne avec son produit.",
    "hiddenOnlineHint": "Vendue en magasin seulement : la boutique en ligne ne la montre pas.",
    "notPublished": "Son produit n'est pas encore dans la boutique en ligne.",
    "online": "En ligne",
    "hidden": "Masquée",
    "onSaleFor": "{{label}} en vente",
    "onlineFor": "{{label}} visible en ligne",
    "select": "Cocher {{label}}",
    "selectAll": "Cocher toutes les variantes",
    "selected_one": "{{count}} variante cochée",
    "selected_many": "{{count}} variantes cochées",
    "selected_other": "{{count}} variantes cochées",
    "putOnSale": "Mettre en vente",
    "takeOffSale": "Retirer de la vente",
    "showOnline": "Montrer en ligne",
    "hideOnline": "Masquer en ligne",
    "clear": "Décocher"
  },
  "variantPhotos": {
    "title": "Photos de cette variante",
    "hint": "Montrées dans la boutique en ligne quand un client choisit cette variante, après sa photo.",
    "galleryHint": "Une variante sans photos à elle montre celles de son produit.",
    "column": "Photos",
    "open": "Photos de {{label}}",
    "dialogTitle": "Photos de {{label}}",
    "copy": "Les utiliser pour d'autres variantes",
    "copyTitle": "Utiliser les photos de {{label}}",
    "copyHint_one": "{{count}} photo, copiée sur les variantes cochées.",
    "copyHint_many": "{{count}} photos, copiées sur les variantes cochées.",
    "copyHint_other": "{{count}} photos, copiées sur les variantes cochées.",
    "copyConfirm_one": "Copier sur {{count}} variante",
    "copyConfirm_many": "Copier sur {{count}} variantes",
    "copyConfirm_other": "Copier sur {{count}} variantes",
    "copied_one": "Photos copiées sur {{count}} variante",
    "copied_many": "Photos copiées sur {{count}} variantes",
    "copied_other": "Photos copiées sur {{count}} variantes",
    "has_one": "{{count}} photo actuellement",
    "has_many": "{{count}} photos actuellement",
    "has_other": "{{count}} photos actuellement",
    "all": "Tout cocher",
    "none": "Tout décocher",
    "replaces": "Leur galerie est remplacée par ces photos, et leur photo aussi quand cette variante en a une. Chaque variante garde ses propres copies."
  },
  "list": {
    "wholesale": "Gros {{price}}"
  },
  "labels": {
    "button": "Imprimer des étiquettes",
    "title": "Étiquettes code-barres",
    "subtitle": "Le format vient de Configuration › Étiquettes ; modifiez-le pour cette impression si besoin.",
    "print": "Imprimer",
    "count_one": "{{count}} étiquette",
    "count_many": "{{count}} étiquettes",
    "count_other": "{{count}} étiquettes",
    "format": "Format d’étiquette",
    "size": "Étiquettes de {{width}} × {{height}} mm",
    "rolls": "Rouleau (imprimante thermique d’étiquettes)",
    "rollSize": "{{width}} × {{height}} mm",
    "customRoll": "Rouleau, autre taille",
    "sheets": "Planche A4 (imprimante de bureau)",
    "sheetGrid_one": "A4, {{columns}} × {{rows}} ({{count}} étiquette)",
    "sheetGrid_many": "A4, {{columns}} × {{rows}} ({{count}} étiquettes)",
    "sheetGrid_other": "A4, {{columns}} × {{rows}} ({{count}} étiquettes)",
    "customSheet": "A4, autre grille",
    "width": "Largeur",
    "height": "Hauteur",
    "columns": "Colonnes",
    "rows": "Lignes",
    "margin": "Marge de la planche",
    "marginHint": "Autour de la grille, de chaque côté.",
    "gap": "Espace entre étiquettes",
    "shows": "Sur l’étiquette",
    "switches": {
      "showOptions": "Les options après le nom (S / Noir)",
      "showPrice": "Le prix",
      "showSku": "La référence (SKU)",
      "showCompany": "Le nom de la boutique"
    },
    "priceList": "Prix affiché",
    "startAt": "Commencer à l’étiquette",
    "startAtHint": "Sur une planche déjà entamée, les premières étiquettes restent vides.",
    "invalid": "Vérifiez le format : étiquettes de 15 à 150 mm, jusqu’à 8 colonnes et 30 lignes.",
    "narrow": "Certains codes-barres sont très serrés sur cette étiquette : choisissez une étiquette plus large, ou vérifiez qu’ils se lisent.",
    "unreadable": "Aucun code-barres ne peut porter {{codes}} : il s’imprime en texte. Donnez à ces produits un code-barres ou une référence sans accents.",
    "noPrice": "Certains produits n’ont pas de prix sur {{list}} : leurs étiquettes n’en affichent pas.",
    "noPriceShort": "sans prix",
    "tooMany": "Au plus {{max}} étiquettes par impression.",
    "copiesOf": "Étiquettes de {{name}}"
  }
}
